module.exports = __webpack_public_path__ + "static/img/solu3.08c168d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Solution/img/solu3.jpg
// module id = eyKv
// module chunks = 1